import React from 'react'
import { useMutation } from 'react-query'
import { AnimalProfilesClient } from '../../../../interactors/clients/AnimalProfilesClient'
import { AnimalProfileDto } from '../../../../interactors/gen/backendClient'
import { useGlobalSnackbarStore } from '../../../../store/GlobalSnackBarStore'
import { Categories } from '../AnimalHealthTab'
import { FeedingInitialQuestions } from '../NutritionInitialQuestions'
import { EditFeedingQuestions } from '../EditFeedingQuestions'

interface Props {
  animalProfile: AnimalProfileDto
  setAnimalProfile: (animalProfile: AnimalProfileDto) => void
  setSelectedCategory: (category: Categories) => void
}

export const Feeding: React.FC<Props> = ({ animalProfile, setAnimalProfile, setSelectedCategory }) => {
  const globalSnackbarStore = useGlobalSnackbarStore()
  const mutation = useMutation(
    (animal: AnimalProfileDto) => {
      return AnimalProfilesClient.editAnimalProfile(animal)
    },
    {
      onSuccess: (animal) => {
        setAnimalProfile(animal)
        globalSnackbarStore.triggerSuccessMessage("Profil de l'animal mis à jour")
        setSelectedCategory(Categories.Score)
      },
      onError: (error) => {
        console.error('Error updating animal profile', error)
        globalSnackbarStore.triggerErrorMessage("Une erreur est survenue lors de la mise à jour du profil de l'animal")
      },
    }
  )
  if (animalProfile.health.score?.feedingQuestions && animalProfile.health.score?.feedingQuestions.length > 0) {
    return <EditFeedingQuestions animalProfile={animalProfile} editMutation={mutation} />
  } else {
    return <FeedingInitialQuestions animalProfile={animalProfile} editMutation={mutation} />
  }
}
